import React from "react";
import { useProductConfig } from "context/ProductContext";

type HeroSectionProps = {
    bannerContent: React.ReactNode;
    cardContent: React.ReactNode;
};

const HeroSection = ({ bannerContent, cardContent }: HeroSectionProps) => {
    const config = useProductConfig();

    return (
        <div className="w-full m-0 p-0 box-border relative flex flex-col overflow-x-clip">
            {/* Background image - full width */}
            <div className="absolute inset-0 w-full h-full">
                <img src={config.assets.heroImage} alt="" className="w-full h-full object-cover pointer-events-none" />
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black/40 pointer-events-none z-[1]" />
            </div>

            {/* Responsive layout - single instance of content */}
            <div className="relative z-[2] flex flex-col tablet:flex-row tablet:items-stretch tablet:max-w-[1200px] tablet:mx-auto tablet:py-16 w-full">
                {/* Banner content */}
                <div className="flex flex-col justify-between min-h-[300px] tablet:min-h-0 tablet:w-[45%] tablet:gap-[262px]">
                    {bannerContent}
                </div>

                {/* Card content */}
                <div className="w-full p-4 bg-gray-200 tablet:bg-transparent tablet:w-[55%] tablet:flex tablet:items-center tablet:justify-center">
                    {cardContent}
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
